module.exports = __webpack_public_path__ + "bf2.no1.21a49742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bf2.no1.jpg
// module id = yCVO
// module chunks = 0